export default __webpack_public_path__ + "static/media/02_SchererGruppe-DTM-Documentary-EschweilerPhotography_M1A2717.3c017cda.jpg";